export * from "./Heading"
export { default } from "./Heading"
